import { z } from 'zod';

// `message` é chave de `auth:validation`; o LoginForm traduz na renderização.
export const loginSchema = z.object({
  email: z.email({ message: 'invalidEmail' }),
  password: z.string().min(8, { message: 'passwordTooShort' }),
});

export type LoginInput = z.infer<typeof loginSchema>;
